// extracted by mini-css-extract-plugin
module.exports = {"cardImgWrapper":"directory-section_cardImgWrapper__7o_Th","card":"directory-section_card__GrpMN"};